import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  name: 'paginationStore',
  namespaced: true,
})
export default class PaginationStore extends VuexModule {
  limit: number = 10;

  @Mutation
  changeLimit(limit: number) {
    this.limit = limit;
  }
}
